import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../store/Application/ApplicationReducer';
import { InitApplicationConfig } from '../store/Application/ApplicationActions';
import { ServerConfig } from '../model/ServerConfig';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  constructor(
    private readonly http: HttpClient,
    private readonly applicationStore: Store<ApplicationState>,
    private readonly router: Router,
  ) {}

  static isLogined(): boolean {
    return localStorage.getItem('currentUser') != null;
  }

  logout() {
    return this.http.post('/api/authentication/signout', {});
  }

  async loadUserInfoFromServer(): Promise<ServerConfig> {
    return this.http
      .get<ServerConfig>('/ch/api/application/preload', {})
      .toPromise()
      .then((resp) => {
        localStorage.setItem('currentUser', JSON.stringify(resp.user));
        this.applicationStore.dispatch(new InitApplicationConfig(resp));
        if (!resp.user) {
          localStorage.removeItem('currentUser');
          this.router.navigate(['login']);
          return null;
        }
        return resp;
      })
      .catch(() => {
        localStorage.removeItem('currentUser');
        this.router.navigate(['login']);
        return null;
      });
  }

  login(token: string) {
    return this.http.post(
      '/ch/api/auth/cognito/login',
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  }
}
